export default {
  sm: `
  재해 복구 이후, 기존 서비스 복구를 위한 시스템을 통해 신속하게 후속 조치를 시행합니다. 또한 지속적인 모의 및 사전 훈련을 통해 재해 복구 경험을 축적하여 실전 대응 능력을 강화합니다.
  `,
};  